export default __webpack_public_path__ + "static/media/many_functions.9810a641.jpg";